module.exports = __webpack_public_path__ + "img/aeroland-clinic-image-01.94e0ca96.png";